import Config from '../Config'
import ApiUrl from '../service/ApiUrl';
import axios from "axios";
import fileDownload from "js-file-download";

class BaseServiceV2 {

    constructor(path) {
        this.path = Config.API_EbasvuruUrl + path;
        this.ApiUrl = ApiUrl;
    }

    /* async search({page = 0, data, max = Config.MAX_RESULT, orderBy = null}) {
         return await easySearch(`${this.path}/search`, page, data, max, orderBy);
     }
 
     async easyExport({data, filename}) {
         await easyExport(`${this.path}/search`, data, filename);
     }
 
     async get(id) {
         return await easyGet(`${this.path}/${id}`);
     }
 
     async save(data) {
         return await easyPost(this.path, data);
     }
 
     async update(id, data) {
         return await easyPut(`${this.path}/${id}`, data);
     }
 
     async saveOrUpdate(id, data) {
         return id ? await this.update(id, data) : await this.save(data)
     }
 
     async delete(id, data) {
         return await easyDelete(`${this.path}/${id}`, data);
     }
 
     async rollback(id) {
         return await easyDelete(`${this.path}/${id}/rollback`, {});
     }*/

    getPagination = async (page = 1, data, max = Config.MAX_RESULT, orderBy = null, takeAll = false) => {
        try {

            const order = orderBy
                ? Array.isArray(orderBy)
                    ? orderBy.map(item => ({
                        key: item?.name ?? 'Id',
                        value: item?.type ?? 'Desc'
                    }))
                    : [{
                        key: orderBy?.name ?? 'Id',
                        value: orderBy?.type ?? 'Desc'
                    }]
                : null;


            const url = this.path + this.ApiUrl.endpoint.Pagination;

            const response = await axios.post(url,
                {
                    filter: { ...data },
                    paging: {
                        PageSize: max,
                        page: page,
                        takeAll: takeAll
                    },
                    order
                },
                {
                    timeout: 60000,
                    headers: {
                        'Content-Type': 'application/json',
                    }
                }
            );

            return response.data;

        } catch (e) {
            console.error(e);
            return null;
        }
    }

    getList = async () => {
        return await this.getPagination(1,
            null,
            9000,
            null,
            true);
    }


    exportCsv = async (data, filename, orderBy = null, cSVList = null) => {

        const order = orderBy ? [{
            key: orderBy?.name ?? 'Id',  // Use optional chaining and nullish coalescing
            value: orderBy?.type ?? 'des'
        }] : null;

        const url = this.path + this.ApiUrl.endpoint.Pagination;

        const response = await axios.post(url,
            {
                isCreateCsv: true,
                filter: { ...data },
                paging: {
                    PageSize: 0,
                    page: 0,
                    takeAll: true
                },
                order,
                cSVList
            },
            {
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/json',
                },
                responseType: 'blob'
            }
        );
        fileDownload(response.data, filename);

    }

    update = async (data) => {
        const url = this.path + this.ApiUrl.endpoint.UpdateDynamic;

        const response = await axios.post(url,
            data,
            {
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;

    }

    fullupdate = async (data) => {
        const url = this.path + this.ApiUrl.endpoint.Update;

        const response = await axios.post(url,
            data,
            {
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;

    }

    create = async (data) => {
        const url = this.path + this.ApiUrl.endpoint.Create;

        const response = await axios.post(url,
            data,
            {
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/json',
                }
            }
        );
        return response.data;

    }

    get = async (paramters, token = null) => {
        const url = this.path + this.ApiUrl.endpoint.Get;

        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (token) {
            header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
        }

        try {
            const response = await axios.get(url, {
                params: { ...paramters },
                timeout: 60000,
                headers: header
            });

            return response.data;

        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    delete = async (id) => {
        const url = this.path + this.ApiUrl.endpoint.Delete;

        try {
            const response = await axios.post(url, id, {
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    remove = async (id) => {
        const url = this.path + this.ApiUrl.endpoint.Remove;

        try {
            const response = await axios.post(url, id, {
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/json',
                }
            }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    easyGet = async (endpoint, paramters = {}, token = '') => {

        const url = this.path + endpoint;
        try {

            let header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            };

            if (token) {

                header = {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                };
            }
            const response = await axios.get(url, {
                params: { ...paramters },
                timeout: 60000,
                headers: header
            });

            return response.data;

        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    fullGet = async (paramters = {}, token = '') => {

        const url = this.path + this.ApiUrl.endpoint.fullGet;
        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (token) {
            header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
        }


        const response = await axios.post(url,
            { ...paramters },
            {
                timeout: 6000000,
                headers: header
            }
        );

        return response.data;
    }

    easyPost = async (endpoint, paramters = {}, token = '') => {


        const url = this.path + endpoint;

        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (token) {
            header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
        }


        const response = await axios.post(url,
            { ...paramters },
            {
                timeout: 6000000,
                headers: header
            }
        );

        return response.data;
    }

    Post = async (endpoint, paramters = {}, token = '') => {


        const url = this.path + endpoint;

        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (token) {
            header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
        }


        const response = await axios.post(url,
            paramters,
            {
                timeout: 6000000,
                headers: header
            }
        );

        return response.data;
    }


    fullPathPost = async (endpoint, paramters = {}, token = '') => {


        const url = Config.API_EbasvuruUrl + endpoint;

        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (token) {
            header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
        }


        const response = await axios.post(url,
            { ...paramters },
            {
                timeout: 60000,
                headers: header
            }
        );
        return response.data;
    }


    easybulkPost = async (endpoint, paramters = {}, token = '') => {

        const url = this.path + endpoint;

        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (token) {
            header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
        }


        const response = await axios.post(url,
            paramters,
            {
                timeout: 60000,
                headers: header
            }
        );
        return response.data;
    }

    fullPathPost = async (endpoint, paramters = {}, token = '') => {


        const url = Config.API_EbasvuruUrl + endpoint;

        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (token) {
            header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
        }


        const response = await axios.post(url,
            { ...paramters },
            {
                timeout: 60000,
                headers: header
            }
        );
        return response.data;
    }

    FilePost = async ({ url, endpoint, paramters = {}, token = '' }) => {



        if (!url) {
            url = this.path + endpoint;

        } else {
            url = Config.API_EbasvuruUrl + url;
        }

        let header = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };

        if (token) {
            header = {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            };
        }


        const response = await axios.post(url,
            paramters,
            {
                timeout: 60000,
                headers: header
            }
        );
        return response.data;
    }

    FileUploadPost = async (url, byteArray, token = '') => {
        url = Config.API_EbasvuruUrl + url;

        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            ...(token && { 'Authorization': `Bearer ${token}` })
        };

        const response = await axios.post(url, byteArray, {
            timeout: 60000,
            headers: headers
        });

        return response.data;
    };


}

export default BaseServiceV2;
